import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es7.object.values";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[typeof Symbol === "function" ? Symbol.iterator : "@@iterator"] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[typeof Symbol === "function" ? Symbol.iterator : "@@iterator"]();
  return it.next.bind(it);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import DiscreteGestureHandler from "./DiscreteGestureHandler";
import * as NodeManager from "./NodeManager";
import PressGestureHandler from "./PressGestureHandler";
import { TEST_MIN_IF_NOT_NAN, VEC_LEN_SQ } from "./utils";

var NativeViewGestureHandler = function (_PressGestureHandler) {
  _inherits(NativeViewGestureHandler, _PressGestureHandler);

  var _super = _createSuper(NativeViewGestureHandler);

  function NativeViewGestureHandler() {
    _classCallCheck(this, NativeViewGestureHandler);

    return _super.apply(this, arguments);
  }

  _createClass(NativeViewGestureHandler, [{
    key: "onRawEvent",
    value: function onRawEvent(ev) {
      var _this = this;

      _get(_getPrototypeOf(NativeViewGestureHandler.prototype), "onRawEvent", this).call(this, ev);

      if (!ev.isFinal) {
        if (TEST_MIN_IF_NOT_NAN(VEC_LEN_SQ({
          x: ev.deltaX,
          y: ev.deltaY
        }), 10)) {
          if (this.config.disallowInterruption) {
            var gestures = Object.values(NodeManager.getNodes()).filter(function (gesture) {
              var handlerTag = gesture.handlerTag,
                  view = gesture.view,
                  isGestureRunning = gesture.isGestureRunning;
              return handlerTag !== _this.handlerTag && isGestureRunning && gesture instanceof DiscreteGestureHandler && view && _this.view.contains(view);
            });

            for (var _iterator = _createForOfIteratorHelperLoose(gestures), _step; !(_step = _iterator()).done;) {
              var gesture = _step.value;
              gesture.forceInvalidate(ev);
            }
          }
        }
      }
    }
  }]);

  return NativeViewGestureHandler;
}(PressGestureHandler);

export default NativeViewGestureHandler;